import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.css'
})
export class ConfirmationModalComponent {

  isVisible = input<boolean>(false)
  /** Custom question text (you can include HTML). */
  message = input<string>('Are you sure you want to delete?');
  isLoading = input<boolean>(false);
  confirmLabel = input<string>('Delete');
  loadingLabel = input<string>('Deleting...');
  icon = input<'delete' | 'signout'>('delete');
  /** Emitted when the user confirms deletion. */
  confirm = output<void>();
  /** Emitted when the user cancels / closes the modal. */
  cancel = output<void>();


  /**
   * Emits the confirm event when the user confirms deletion.
   */
  onConfirm() {
    this.confirm.emit();
  }

  /**
   * Emits the cancel event when the user clicks the cancel button or closes the modal.
   */
  onCancel() {
    this.cancel.emit();
  }
}
